"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyRewardsLedgerEntryEntity = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const BadRequestError_1 = require("../GS/BadRequestError");
const CustomerProfileDto_1 = require("../customer-profiles/CustomerProfileDto");
const CustomerProfileEntity_1 = require("../customer-profiles/CustomerProfileEntity");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const LoyaltyRewardsLedgerEntryDto_1 = require("./LoyaltyRewardsLedgerEntryDto");
const LoyaltyRewardsTasksEntity_1 = require("../loyalty-rewards-and-tasks/LoyaltyRewardsTasksEntity");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class LoyaltyRewardsLedgerEntryEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, loyaltyRewardsLedgerEntry) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            locationId: false,
            locationName: false,
            customerProfileId: false,
            title: false,
            description: false,
            points: false
        };
        this._dependencies = dependencies;
        if (loyaltyRewardsLedgerEntry === undefined) {
            this._dto = new LoyaltyRewardsLedgerEntryDto_1.LoyaltyRewardsLedgerEntryDto();
        }
        else if (loyaltyRewardsLedgerEntry instanceof LoyaltyRewardsLedgerEntryDto_1.LoyaltyRewardsLedgerEntryDto) {
            this._dto = new LoyaltyRewardsLedgerEntryDto_1.LoyaltyRewardsLedgerEntryDto(loyaltyRewardsLedgerEntry);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (loyaltyRewardsLedgerEntry instanceof LoyaltyRewardsLedgerEntryEntity) {
            this._dto = new LoyaltyRewardsLedgerEntryDto_1.LoyaltyRewardsLedgerEntryDto(loyaltyRewardsLedgerEntry._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new LoyaltyRewardsLedgerEntryDto_1.LoyaltyRewardsLedgerEntryDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    getAppId() {
        return this._dto.appId;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getLoyaltyRewardOrTask() {
        if (this._dto.loyaltyRewardOrTaskId === undefined) {
            return undefined;
        }
        if (this._dto.loyaltyRewardOrTask === undefined) {
            throw new Error("Cannot call getLoyaltyRewardOrTask " +
                "without first loading the LoyaltyRewardOrTask.");
        }
        if (!this._loyaltyRewardOrTaskEntity && this._dto.loyaltyRewardOrTask) {
            this._loyaltyRewardOrTaskEntity = new LoyaltyRewardsTasksEntity_1.LoyaltyRewardsTasksEntity(this._dependencies, this._dto.loyaltyRewardOrTask);
        }
        return this._loyaltyRewardOrTaskEntity;
    }
    setLoyaltyRewardOrTask(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLoyaltyRewardOrTaskId(untrustedId);
        if (this.hasError("loyaltyRewardOrTaskId")) {
            return;
        }
        if (untrustedValue instanceof LoyaltyRewardsTasksEntity_1.LoyaltyRewardsTasksEntity) {
            this._loyaltyRewardOrTaskEntity = untrustedValue;
        }
    }
    getLoyaltyRewardOrTaskId() {
        return this._dto.loyaltyRewardOrTaskId;
    }
    setLoyaltyRewardOrTaskId(untrustedValue) {
        let _untrustedValue;
        this.clearError("loyaltyRewardOrTaskId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("loyaltyRewardOrTaskId", "Loyalty Reward Or Task Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.loyaltyRewardOrTaskId) {
            return;
        }
        this._dto.loyaltyRewardOrTaskId = _untrustedValue;
        delete this._loyaltyRewardOrTaskEntity;
        this._setIsDirty(true);
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getLocationName() {
        return this._dto.locationName;
    }
    setLocationName(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("locationName");
        this._requiredFieldsSetStatus.locationName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("locationName", "Location Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("locationName", `Location Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationName) {
            return;
        }
        this._dto.locationName = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomerProfile() {
        if (this._dto.customerProfileId === undefined) {
            return undefined;
        }
        if (this._dto.customerProfile === undefined) {
            throw new Error("Cannot call getCustomerProfile without " +
                "first loading the CustomerProfile.");
        }
        if (!this._customerProfileEntity && this._dto.customerProfile) {
            this._customerProfileEntity = new CustomerProfileEntity_1.CustomerProfileEntity(this._dependencies, this._dto.customerProfile);
        }
        return this._customerProfileEntity;
    }
    setCustomerProfile(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof CustomerProfileEntity_1.CustomerProfileEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof CustomerProfileDto_1.CustomerProfileDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setCustomerProfileId(untrustedId);
        if (this.hasError("customerProfileId")) {
            return;
        }
        if (untrustedValue instanceof CustomerProfileEntity_1.CustomerProfileEntity) {
            this._customerProfileEntity = untrustedValue;
        }
    }
    getCustomerProfileId() {
        return this._dto.customerProfileId;
    }
    setCustomerProfileId(untrustedValue) {
        let _untrustedValue;
        this.clearError("customerProfileId");
        this._requiredFieldsSetStatus.customerProfileId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("customerProfileId", "Customer Profile Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("customerProfileId", "Customer Profile is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.customerProfileId) {
            return;
        }
        this._dto.customerProfileId = _untrustedValue;
        this._dto.customerId = _untrustedValue;
        delete this._customerProfileEntity;
        this._setIsDirty(true);
    }
    getTitle() {
        return this._dto.title;
    }
    setTitle(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("title");
        this._requiredFieldsSetStatus.title = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("title", "Title is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("title", `Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.title) {
            return;
        }
        this._dto.title = _untrustedValue;
        this._setIsDirty(true);
    }
    getDescription() {
        return this._dto.description;
    }
    setDescription(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("description");
        this._requiredFieldsSetStatus.description = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("description", "Description is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("description", `Description has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.description) {
            return;
        }
        this._dto.description = _untrustedValue;
        this._setIsDirty(true);
    }
    getPoints() {
        return this._dto.points;
    }
    setPoints(untrustedValue) {
        let _untrustedValue;
        this.clearError("points");
        this._requiredFieldsSetStatus.points = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("points", "Points is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("points", "Points is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.points) {
            return;
        }
        this._dto.points = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadCustomerProfileAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getCustomerProfileId()) {
                    return;
                }
                this._emit("before-loadCustomerProfileAsync");
                this._dto.customerProfile =
                    yield this._dependencies.customerProfileDatastore
                        .getAsync(this.getCustomerProfileId(), expand);
                delete this._customerProfileEntity;
                this._emit("after-loadCustomerProfileAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLoyaltyRewardOrTaskAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLoyaltyRewardOrTaskId()) {
                    return;
                }
                this._emit("before-loadLoyaltyRewardOrTaskAsync");
                this._dto.loyaltyRewardOrTask =
                    yield this._dependencies.loyaltyRewardsTasksDatastore
                        .getAsync(this.getLoyaltyRewardOrTaskId(), expand);
                delete this._loyaltyRewardOrTaskEntity;
                this._emit("after-loadLoyaltyRewardOrTaskAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.loyaltyRewardsLedgerEntryDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Loyalty Rewards Ledger Entry is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.loyaltyRewardsLedgerEntryDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.loyaltyRewardsLedgerEntryDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Loyalty Rewards Ledger Entry cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.loyaltyRewardsLedgerEntryDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.LoyaltyRewardsLedgerEntryEntity = LoyaltyRewardsLedgerEntryEntity;
//# sourceMappingURL=LoyaltyRewardsLedgerEntryEntity.js.map